<template>
    <div>
        <v-row justify="center">
            <v-col cols="10">
                <v-expansion-panels inset>
                    <v-expansion-panel key="1">
                        <v-expansion-panel-header>
                            <v-row>
                                <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                                <span id="paneltitle" class="mt-5">Registrations Overview</span>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <registrations-table></registrations-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- <v-expansion-panel
            key="2"
          >
            <v-expansion-panel-header>
              <v-row>
                <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                <span id="paneltitle" class="mt-5">Create Company</span> 
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <company-create></company-create>
            </v-expansion-panel-content>
          </v-expansion-panel> -->
                </v-expansion-panels>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    // import CompanyCreate from '@/components/admin/CompanyCreate.vue';
    import RegistrationsTable from "@/components/admin/RegistrationsTable.vue"

    export default {
        components: {
            // CompanyCreate,
            RegistrationsTable
        },
        data: () => ({}),
        methods: {},
        mounted() {}
    }
</script>

<style lang="css" scoped>
    #userimage {
        margin-left: 5px;
        max-width: 60px !important;
    }
    #paneltitle {
        margin-left: 15px;
        font-size: 1.5em;
        padding-top: auto;
        padding-bottom: auto;
    }
</style>
